import { buildClassName } from './buildClassName';
import type { StudioOption } from '../types';

export interface StudioSwatchGroupProps {
  options: StudioOption[];
  selectedOptionId: string;
  onOptionSelect: (optionId: string) => void;
}

/**
 * 배경 프리셋 스와치.
 *
 * 프리셋의 실제 배경색과 바닥색을 그대로 그라디언트로 써서, 스와치가 뷰어에
 * 나타날 결과를 그대로 미리 보여 주도록 했습니다. 별도 프리뷰 색을 두면
 * 프리셋을 손볼 때마다 두 군데를 맞춰야 하고 결국 어긋납니다.
 */
export function StudioSwatchGroup({ options, selectedOptionId, onOptionSelect }: StudioSwatchGroupProps) {
  return (
    <ul className="swatch-list" aria-label="배경 선택">
      {options.map((option) => {
        const isSelected = option.id === selectedOptionId;
        // 프리셋의 첫 Lightformer 색을 스와치 상단 하이라이트로 씁니다.
        // 색이 지정되지 않은 Lightformer는 흰색으로 발광합니다.
        const keyColor = option.lightformers.find((lightformer) => lightformer.color !== undefined)?.color ?? '#ffffff';
        return (
          <li key={option.id}>
            <button
              type="button"
              className={buildClassName('swatch', 'swatch--selected', isSelected)}
              aria-pressed={isSelected}
              aria-label={`${option.name} · ${option.description}`}
              title={`${option.name} · ${option.description}`}
              onClick={() => onOptionSelect(option.id)}
            >
              <span
                className="swatch__color"
                style={{
                  background: `radial-gradient(circle at 50% 22%, ${keyColor} 0%, ${option.backgroundColor} 55%, ${option.floorColor} 100%)`,
                }}
              />
            </button>
          </li>
        );
      })}
    </ul>
  );
}
